import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-modal-inventory-report',
  standalone: true,
  template: `
    <ng-template #modalInventoryReport let-modal>
      <div class="modal-header">
        <div class="modal-title">Intervalo de fechas</div>
      </div>
      <div class="modal-body p-4">
        <div class="row">
          <div class="col-md-12">
            <form [formGroup]="inventoryForm" (ngSubmit)="generateReport()">
              <div class="form-group mt-4">
                <label for="payment_date">Fecha de inicio</label>
                <input type="date" class="form-control form-conrol-lg" formControlName="created_at_since">                    
              </div>
              <div class="form-group mt-4">
                <label for="payment_date">Fecha de fin</label>
                <input type="date" class="form-control form-conrol-lg" formControlName="created_at_to">                    
              </div>
              <div class="form-group mt-4 text-end">
                <button type="submit" class="btn btn-primary btn-lg rounded-5">
                  <fa-icon [icon]="icons.faFileExcel" class="me-2" *ngIf="!loading"></fa-icon>
                  <fa-icon [icon]="icons.faCircleNotch" animation="spin" class="me-2" *ngIf="loading"></fa-icon>
                  Generar reporte
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </ng-template>
  `,
  imports: [
    ReactiveFormsModule,
    FontAwesomeModule
  ],
  styleUrls: []
})
export class ModalInventoryReportComponent implements OnInit {
  @Input() profile: any;
  @Input() loading: any;
  @Output() createReport: EventEmitter<any> = new EventEmitter();
  @ViewChild('modalInventoryReport', { static: false }) modalInventoryReport !: ElementRef;

  private modalRef: NgbModalRef | undefined;

  inventoryForm: FormGroup = new FormGroup({});

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    public icons: IconsService,
    private modalService: NgbModal,
  ) {}

  ngOnInit(): void {
    this.inventoryForm = this.fb.group({
      created_at_since: [''],
      created_at_to: ['']
    });
  }

  generateReport() {
    console.log('GENERATE REPORT ==>', this.inventoryForm.value);
    this.createReport.emit(this.inventoryForm.value); 
  }

  openModal(modalContent: TemplateRef<any>) {
    this.modalRef = this.modalService.open(modalContent);
  }

  dismiss() {
    if (this.modalRef) {
      this.createReport.emit();
      this.modalRef.dismiss();
    }
  }

}
